var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2222 4V5.77778H5.77778V18.2222H18.2222V13.7778H20V19.1111C20 19.3469 19.9064 19.573 19.7397 19.7397C19.573 19.9064 19.3469 20 19.1111 20H4.88889C4.65314 20 4.42705 19.9064 4.26035 19.7397C4.09365 19.573 4 19.3469 4 19.1111V4.88889C4 4.65314 4.09365 4.42705 4.26035 4.26035C4.42705 4.09365 4.65314 4 4.88889 4H10.2222ZM16.9653 5.77778H12.8889V4H20V11.1111H18.2222V7.03467L12 13.2569L10.7431 12L16.9653 5.77778Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareLine);
export default __webpack_public_path__ + "static/media/icon-share-line.db507255ce7d4a5d2b16a1b6706d42fe.svg";
export { ForwardRef as ReactComponent };